import React, { useState } from 'react'
import {
	Modal,
	ModalSection,
	Row,
	Typography,
	PrimaryButton,
} from '@copyrightagent/basic-components'
import { Button, TextareaAutosize } from '@material-ui/core'
import { uploadTransferAgreementImages } from '../api'
import { toast } from '../../../../store/utils'
import globalUseStyle from '../style'
import useStyle from './UploadImagesModalStyle'
import { useTransferAgreementsStore } from '../stores/transferAgreementStore'
import { useTransferAgreementImagesStore } from '../stores/transferAgreementImagesStore'

export const UploadImagesModal = () => {
	const {
		fetchTransferAgreementImages,
		uploadImagesModalOpen,
		setUploadImagesModalOpen,
		selectedTransferAgreement,
		setSearchString,
	} = useTransferAgreementImagesStore()

	const transferAgreementsStore = useTransferAgreementsStore()
	const globalClasses = globalUseStyle()
	const classes = useStyle()

	const [uploading, setUploading] = useState(false)
	const [partnerImageIdsString, setPartnerImageIdsString] = useState<string>('')

	const handleClose = () => {
		setUploadImagesModalOpen(false)
	}

	const submitTransferAgreementImages = async () => {
		setUploading(true)

		const partnerImageIds = partnerImageIdsString
			.split('\n')
			.flatMap((line) => line.split(','))
			.filter(Boolean)

		const response = await uploadTransferAgreementImages({
			partnerImageIds,
			transferAgreementId: selectedTransferAgreement!.transfer_agreement_id,
		})
		setUploading(false)
		if (response.isSuccessful) {
			setSearchString('')
			fetchTransferAgreementImages(
				selectedTransferAgreement!.transfer_agreement_id,
				{
					isInitialLoad: true,
				},
			)
			const foundTransferAgreement =
				transferAgreementsStore.transferAgreements.find(
					(transferAgreement) =>
						transferAgreement.transfer_agreement_id ===
						selectedTransferAgreement!.transfer_agreement_id,
				)

			if (foundTransferAgreement) {
				transferAgreementsStore.incrementTransferAgreementImageCount({
					transferAgreementId: selectedTransferAgreement!.transfer_agreement_id,
					incrementImageCountBy: partnerImageIds.length,
				})
			}
			setPartnerImageIdsString('')
			await toast('Image IDs successfully added.', 'success')
		} else {
			await toast('Something went wrong. Please try again later', 'error')
		}
	}

	const handleCancel = () => {
		setPartnerImageIdsString('')
		handleClose()
	}

	return (
		<Modal
			open={uploadImagesModalOpen}
			onClose={handleClose}
			title={`Link image IDs to agreement with ${
				selectedTransferAgreement!.photographer_name
			}`}
			titleText={
				'Manually type in images, seperated either by a comma or by a new line, or both!'
			}
			size="large"
		>
			<ModalSection>
				<TextareaAutosize
					value={partnerImageIdsString}
					onChange={(e) => setPartnerImageIdsString(e.target.value)}
					className={classes.textArea}
				/>
			</ModalSection>
			<ModalSection>
				<Row justify="flex-end">
					<Button
						className={globalClasses.invisibleButton}
						onClick={handleCancel}
					>
						<Typography>Cancel</Typography>
					</Button>
					<PrimaryButton
						type="submit"
						loading={uploading}
						text={'Link Images'}
						loadingText={'Linking Images'}
						onClick={submitTransferAgreementImages}
						disabled={uploading || !partnerImageIdsString}
					/>
				</Row>
			</ModalSection>
		</Modal>
	)
}
